import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useUserContext } from "../contexts/userContext";
const UnAutherizeRoute = (props) => {
  let { user } = useUserContext();
  let navigator = useNavigate();
  useEffect(() => {
    if (user) {
      navigator("/");
    } 
  }, [user]);

  return <Outlet {...props} />;
};

export default UnAutherizeRoute;
